<template>
  <div>
    <b-card>
      <!-- <div class="col-md-4">
          <b-form-group label="درگاه">
            <b-form-select :options="gateways" v-model="gid"> </b-form-select>
          </b-form-group>
        </div> -->

      <b-card-text>
        <list-table
          :url="transactions.url"
          :btns="transactions.btns"
          title="لیست تراکنش ها"
          :fields="transactions.fields"
          :params="transactions.params"
          :detailCallFun="transactions.detailCallFun"
          :detailCallFunType="transactions.detailCallFunType"
          :excelroute="'asdasd'"
          @handle_function_call="ShowDetail"
        ></list-table>
      </b-card-text>
    </b-card>

    <b-modal id="transaction-details" hide-footer>
      <template v-slot:modal-title>اطلاعات تراکنش</template>
      <div class="d-block">
        <b-row>
          <b-col cols="6">
            <b-form-group label="وضعیت:">
              <div class="form-control">
                {{ trDetail.is_verify == 1 ? "تایید شده" : "تایید نشده" }}
              </div>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group label="مبلغ:">
              <div class="form-control">
                {{ Number(trDetail.cost).toLocaleString() }}
              </div>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group label="تاریخ و ساعت:">
              <div class="form-control">
                {{ trDetail.created_at }}
              </div>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group label="آدرس درخواست دهنده:">
              <div class="form-control">
                <!-- <b-img
              :src="
                'media/svg/flags/' +
                trDetail.location.countryCode.toLowerCase() +
                '.svg'
              "
              height="20px"
            ></b-img> -->
                {{ trDetail.ip }}
              </div>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group label="کد رهگیری پرداخت:">
              <div class="form-control">{{ trDetail.sale_refrence_id }}</div>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group label="شماره کارت:">
              <div class="form-control sc-card-pan">
                {{ trDetail.card_holder_pan }}
              </div>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group label="توکن:">
              <div class="form-control sc-card-pan">
                {{ trDetail.ref_id }}
              </div>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group label="کد خطا:">
              <div class="form-control sc-card-pan">
                {{ trDetail.error_code }}
              </div>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group label="نام و نام خانوادگی:">
              <div class="form-control sc-card-pan">
                {{ trDetail.name }}
              </div>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group label="پست الکترونیکی:">
              <div class="form-control sc-card-pan">
                {{ trDetail.email }}
              </div>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group label="شماره موبایل:">
              <div class="form-control sc-card-pan">
                {{ trDetail.mobile }}
              </div>
            </b-form-group>
          </b-col>
        </b-row>
      </div>
      <b-button class="mt-3" block @click="$bvModal.hide('transaction-details')"
        >بستن</b-button
      >
    </b-modal>

    <b-modal
      id="transaction-verification"
      title="تایید تراکنش"
      @ok="VerifyTransaction"
      ok-title="بلی"
      cancel-title="خیر"
    >
      آیا از تایید تراکنش اطمینان دارید؟
    </b-modal>
  </div>
</template>
<style>
.sc-card-pan {
  direction: ltr;
}
.ltrdir {
  direction: ltr;
}
</style>
<script>
import TableShowData from "../../components/table";
import MDDropdown from "../../components/MDDropdown";
import persianDate from "../../helpers/persianDate";
import httpHelper from "../../helpers/httpHelper";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import * as moment from "jalali-moment";

export default {
  props: ["apiParams"],
  name: "TransactionList",
  data() {
    return {
      id_for_verify: null,
      user: {},
      trDetail: { location: { countryCode: "IR" } },

      gateways: [],
      transactions: {
        btns: [
          {
            icon: "card-checklist",
            title: "تایید تراکنش",
            handler: (e) => {
              this.id_for_verify = e.id;
              this.$bvModal.show("transaction-verification");
            },
          },
        ],
        url: this.apiParams
          ? `~reports/api/admin-transactions?mdid12_money_type=1722`
          : "~reports/api/admin-transactions",
        detailCallFunType: "id",
        detailCallFun: "ShowDetail",
        fields: [
          {
            key: "id",
            label: "شماره تراکنش",
          },
          {
            key: "website_name",
            label: "نام پذیرنده",
          },
          // {
          //   key: "mobile",
          //   label: "شماره همراه",
          // },
          //  {
          //   key: "email",
          //   label: "ایمیل",
          // },
          // {
          //   key: "gateway.website",
          //   label: "وبسایت",
          // },
          {
            key: "created_at",
            label: "تاریخ تراکنش",
            formatter: (value, key, item) => {
              return moment(value, "YYYY/MM/DDTHH:mm:ss").format(
                "jYYYY/jMM/jDD HH:mm:ss"
              );
            },
            tdClass: (value, key, item) => {
              return "ltrdir";
            },
          },
          {
            key: "is_verify",
            label: "وضعیت",
            formatter: (value, key, item) => {
              return value ? "پرداخت شده" : "پرداخت نشده";
            },
            tdClass: (value, key, item) => {
              return value ? "text-success" : "text-danger";
            },
          },
          {
            key: "is_direct",
            label: "نوع درگاه",
            formatter: (value, key, item) => {
              return value ? "مستقیم" : "واسط";
            },
            tdClass: "text-primary",
          },
          {
            key: "sale_refrence_id",
            label: "کد رهگیری",
          },
          {
            key: "shepa_karmozd",
            label: "کارمزد",
            formatter: (value, key, item) => {
              return Number(value).toLocaleString();
            },
          },
          {
            key: "shaparak_karmozd",
            label: "کارمزد شبکه بانکی",
            formatter: (value, key, item) => {
              return Number(value).toLocaleString();
            },
          },
          {
            key: "cost",
            label: "مبلغ",
            formatter: (value, key, item) => {
              return Number(value).toLocaleString();
            },
          },
          // {
          //   key: "card_holder_pan",
          //   label: "شماره کارت",
          //   tdClass: "sc-card-pan",
          // },
          // {
          //   key: "title",
          //   label: "نام بانک",
          // },
          // {
          //   key: "verify_date",
          //   label: "تاریخ و ساعت تایید",
          //   formatter: (value, key, item) => {
          //     return persianDate.getDateByFormat(value);
          //   },
          // },
          {
            key: "btns",
            label: "عملیات",
          },
          {
            key: "details",
            label: "جزییات",
          },
        ],
        params: [
          {
            label: "از تاریخ",
            field: "date_from",
            value: moment().format("jYYYY/jMM/jDD"),
            type: "date-picker",
          },
          {
            label: "تا تاریخ",
            field: "date_to",
            // value: moment().format("jYYYY/jMM/jDD"),
            type: "date-picker",
          },
          {
            label: "کد رهگیری پرداخت",
            field: "sale_refrence_id",
            type: "text",
          },
          {
            label: "مبلغ",
            field: "cost",
            type: "number",
          },
          {
            label: "چهار رقم آخر کارت",
            field: "card_holder_pan",
            type: "text",
          },
          {
            label: "آدرس وبسایت",
            field: "website_name",
            type: "text",
          },
          {
            label: "شماره تراکنش",
            field: "trans_id",
            type: "text",
          },
          {
            label: "وضعیت",
            field: "is_verify",
            type: "select",
            value: null,
            options: [
              { text: "همه ی موارد", value: null },
              { text: "پرداخت شده ها", value: "1" },
              { text: "پرداخت نشده ها", value: "0" },
            ],
          },
          {
            label: "نوع درگاه",
            field: "is_direct",
            type: "select",
            value: null,
            options: [
              { text: "همه ی موارد", value: null },
              { text: "مستقیم", value: "1" },
              { text: "واسط", value: "0" },
            ],
          },
        ],
      },
    };
  },
  components: {
    "list-table": TableShowData,
  },
  created() {
    httpHelper.setAuth();
  },
  methods: {
    VerifyTransaction(e) {
      e.preventDefault();
      httpHelper
        .getData(
          "~transaction/transaction/admin/verify_trans/" + this.id_for_verify
        )
        .then((res) => {
          this.$bvModal.hide("transaction-verification");
          this.transactions.url =
            this.transactions.url + "&time=" + new Date().getTime();
        });
    },
    ShowDetail(item, type) {
      url = "";
      if (type == "id" && item.id != null) {
        var url = "~/transaction/transaction/" + item.api_token;
      }
      if (type == "transaction_id" && item.transaction_id != null) {
        var url = "transactions?id=" + item.transaction_id;
      }
      if (url != "") {
        this.trDetail = item;
        this.$bvModal.show("transaction-details");
        // httpHelper.getData(url).then((res) => {

        // });
      }
    },

    LoadGateways() {
      httpHelper
        .getData("paymentgateways?p=not&user_id=" + this.$route.params.id)
        .then((response) => {
          this.gateways = response.result.map(function (o) {
            return {
              text: o.website_name,
              value: o.id,
            };
          });
        });
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "تراکنش های ریالی" }]);
    if (this.apiParams) {
      this.transactions.params = this.transactions.params.filter(
        (v) => v.field != "cardNumber"
      );
      this.transactions.fields = this.transactions.fields.filter(
        (v) => v.key != "card_holder_pan"
      );
    }
  },
};
</script>
